// @flow

import {resolve} from '@markdoc/markdoc';

import type {Node as MarkdocAstNode} from '@markdoc/markdoc';
import type {Config as MarkdocConfig} from 'docs/markdoc/types';
import type {CodeGeneratorSnippetArgs} from '../../../../../server/services';

export const REPLACEMENT_KEY = '$$TEST_KEY_REPLACE_ME$$';
export const REPLACEMENT_API_VERSION = '$$API_VERSION_REPLACE_ME$$';

export const BETA_LANGUAGES = ['curl', 'ruby', 'python', 'php', 'node'];

export const LANGUAGES = [
  'curl',
  'cli',
  'ruby',
  'python',
  'php',
  'java',
  'node',
  'go',
  'dotnet',
];

export const codegenNodeToCodegenArgs = (
  node: MarkdocAstNode,
  config: MarkdocConfig,
): CodeGeneratorSnippetArgs => {
  // This resolves args like $merchant.currency to be
  // the value in the config
  const content: MarkdocAstNode = (resolve(node, config): any);

  const attributes: {
    path: string,
    method: string,
    args: any,
    gated: ?Array<string>,
    betaHeader: ?string,
  } = (content.attributes: any);

  const requestArgs: CodeGeneratorSnippetArgs = {
    test_key: REPLACEMENT_KEY,
    path: attributes.path,
    verb: attributes.method.toLowerCase(),
    args: attributes.args,
    gated: attributes.gated || undefined,
    api_version: attributes.betaHeader
      ? `${REPLACEMENT_API_VERSION}; ${attributes.betaHeader}`
      : undefined,
  };

  return requestArgs;
};
